import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { serviceLogout } from '../../service/AuthService';

const LogoutComponent = (): React.ReactElement | null => {
  const navigate = useNavigate();

  useEffect(() => {
    serviceLogout();
    navigate('/login');
  }, [navigate]);

  return null;
};

export default LogoutComponent;
